import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { TextField } from '@material-ui/core';

function Input(props) {
    const { name, ...rest } = props;

    return (
        <div className="form-element">
            <Field name={name}>
                {({ field, form }) => {
                    return (
                        <TextField
                            variant="outlined"
                            autoComplete="off"
                            fullWidth
                            name={name}
                            value={form.values[name]}
                            error={form.touched[name] && Boolean(form.errors[name])}
                            helperText={form.touched[name] && form.errors[name]}
                            onChange={(e) => form.setFieldValue(name, e.target.value)}
                            onBlur={() => form.setFieldTouched(name, true)}
                            {...rest}
                        />
                    );
                }}
            </Field>
        </div>
    );
}

Input.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.string,
};

export default Input;
